enum nationalIdLabels {
  GB = 'National Insurance Number (National ID)',
  US = 'Social Security Number (SSN)',
  CA = 'Social Insurance Number (SIN)',
}

const defaultTinPlaceHolderLabel = 'Tax Identification Number';
const defaultNationalIdLabel = 'National Identification Number (National ID)';

export function getNationalIdLabel(countryCode: string, tin = false): string {
  return (
    nationalIdLabels[countryCode] ||
    (tin ? defaultTinPlaceHolderLabel : defaultNationalIdLabel)
  );
}
